import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/envo-icon-post/logo.svg'
import _imports_1 from '@/assets/img/envo-icon-post/defualt-tx.png'
import _imports_2 from '@/assets/img/envo-icon-post/video.png'
import _imports_3 from '@/assets/img/envo-icon-post/redBg.svg'
import _imports_4 from '@/assets/img/envo-icon-post/Heart.svg'
import _imports_5 from '@/assets/img/envo-icon-post/forward.svg'
import _imports_6 from '@/assets/img/envo-icon-post/Star.svg'
import _imports_7 from '@/assets/img/envo-icon-post/right-go.svg'
import _imports_8 from '@/assets/img/envo-icon-post/Nodata.svg'


const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass({
      home: true,
    })
}
const _hoisted_2 = { class: "trnasiTopDowm" }
const _hoisted_3 = { class: "user_info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "user_tx",
  src: _imports_1
}
const _hoisted_6 = { class: "user_right" }
const _hoisted_7 = { class: "user_r_l" }
const _hoisted_8 = { class: "user_r_l_t" }
const _hoisted_9 = { class: "user_r_l_b" }
const _hoisted_10 = { class: "mainTxt" }
const _hoisted_11 = {
  key: 0,
  class: "videoBox"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "imgList"
}
const _hoisted_15 = { class: "imgItem" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 3,
  class: "redPacket"
}
const _hoisted_18 = { class: "redMain" }
const _hoisted_19 = { class: "redMainTitle" }
const _hoisted_20 = { class: "redMainTxt" }
const _hoisted_21 = { class: "followAll" }
const _hoisted_22 = { class: "followItem" }
const _hoisted_23 = { class: "followItem" }
const _hoisted_24 = { class: "followItem" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = {
  key: 4,
  class: "comment"
}
const _hoisted_27 = {
  key: 5,
  class: "seeMore"
}
const _hoisted_28 = {
  key: 6,
  class: "noComment"
}
const _hoisted_29 = { class: "noCommentTitle" }
const _hoisted_30 = { class: "noCommentTxt" }
const _hoisted_31 = {
  key: 1,
  class: "noData"
}

import { getArticleDetail, getcommentList } from '@/api/article';
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import commentItem from './components/commentItem.vue';
import i18n from '@/language';
import useOpenApp from '@/hooks/useOpenApp';
import useDownloadApp from '@/hooks/useDownloadApp';

export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const route = useRoute();
const openInstall = ref();
const detail: any = ref(null);
const commentList: any = ref([]);
const commentTotal = ref(0);

const { openApp } = useOpenApp();

const { downloadApp } = useDownloadApp();

const getcomment = async () => {
  try {
    let res = await getcommentList({
      keyId: route.query.id,
      pageNum: 1,
      pageSize: 3,
    });
    // console.log(res,"resresresresresresresres");
    commentList.value = res.value.result.list;
    commentTotal.value = res.value.result.total || 0;
  } catch (error) {
    console.log(error);
  }
};
const getArticleDetailApi = async () => {
  try {
    let res = await getArticleDetail(route.query.id);
    if (res.value) {
      if (res.value.result.openStatus == 0) {
        let data = res.value.result;
        if (data.forwardType == 1) {
          data = res.value.result.fromSocialArticleVo;
        }
        detail.value = data;
        if (data.imgJson) {
          detail.value.imgJson = JSON.parse(data.imgJson);
        }
        console.log(detail.value);
      }
    }
  } catch (error) {}
};
const ismaxten = (num: any) => {
  if (num < 10) {
    return '0' + num;
  } else {
    return num;
  }
};
const formatTime = (date: any) => {
  let lowdate = new Date(date);
  let newdate = new Date();
  if (newdate.getTime() - lowdate.getTime() > 86400000) {
    return (
      lowdate.getFullYear() +
      '-' +
      ismaxten(lowdate.getMonth() + 1) +
      '-' +
      ismaxten(lowdate.getDate()) +
      ' ' +
      ismaxten(lowdate.getHours()) +
      ':' +
      ismaxten(lowdate.getMinutes())
    );
  } else {
    return ismaxten(lowdate.getHours()) + ':' + ismaxten(lowdate.getMinutes());
  }
};
// 直接拉起
const schemeWakeup = () => {
  let res = openInstall.value.schemeWakeup({
    data: route.query,
    channelCode: route.query.channelCode,
  });
  console.log(res, 'resresres');
};
// 安装
const wakeupOrInstall = () => {
  openInstall.value.wakeupOrInstall({
    data: route.query,
    channelCode: route.query.channelCode,
  });
};
const initOpeninstall = () => {
  if (!route.query.channelCode) return;
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = '//web.cdn.openinstall.io/openinstall.js';
  s.addEventListener(
    'load',
    () => {
      var data = window.OpenInstall.parseUrlParams(); //解析获取参数
      console.log(data, 'datadatadata');
      openInstall.value = new window.OpenInstall(
        {
          appKey: 'd0g5y4', //根据自己项目配置
          //apkFileName : 'xx.apk',//自定义下载时的apk包名
          preferWakeup: true,
          channelCode: route.query.channelCode,
          mask: function () {
            return;
            ("<div  id='openinstall_shadow'style='position:fixed;left:0;top:0;background:rgba(0,255,0,			0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>");
          }, //自定义打开时的遮罩样式
          //openinstall初始化完成的回调函数，可选
          onready: function () {
            schemeWakeup();
          },
        },
        data
      );
    },
    false
  );
  document.head.appendChild(s);
};
getArticleDetailApi();
getcomment();
onMounted(() => {
  if (route.query.i18n) {
    i18n.global.locale = route.query.i18n as 'zh' | 'zhTw' | 'en' | 'es' | 'ms';
  }
  initOpeninstall();
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "trnasiTopDowmL" }, [
        _createElementVNode("img", {
          class: "l logoogo",
          src: _imports_0
        })
      ], -1)),
      _createVNode(_component_a_button, {
        onClick: _cache[0] || (_cache[0] = 
          () => {
            _unref(downloadApp)();
          }
        ),
        class: "trnasiTopDowmR"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('XZ')), 1)
        ]),
        _: 1
      })
    ]),
    (detail.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: wakeupOrInstall,
          class: "main"
        }, [
          _createElementVNode("div", _hoisted_3, [
            (detail.value && detail.value.portrait)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "user_tx",
                  src: detail.value && detail.value.portrait
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString((detail.value && detail.value.displayName) || '--'), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(formatTime(detail.value && detail.value.createAt)), 1)
              ]),
              _createVNode(_component_a_button, {
                onClick: wakeupOrInstall,
                class: "user_r_r"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('GZ')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(detail.value && detail.value.content), 1),
          (detail.value.type == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mask" }, [
                  _createElementVNode("img", { src: _imports_2 })
                ], -1)),
                (
            detail.value &&
            detail.value.imgJson &&
            detail.value.imgJson.length == 1 &&
            detail.value.type == 2
          )
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "imgbox",
                      src: detail.value.imgJson[0].t
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (
          detail.value &&
          detail.value.imgJson &&
          detail.value.imgJson.length == 1 &&
          detail.value.type == 1
        )
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "imgbox",
                src: detail.value.imgJson[0].imgUrl
              }, null, 8, _hoisted_13))
            : _createCommentVNode("", true),
          (detail.value && detail.value.imgJson && detail.value.imgJson.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.imgJson, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("img", {
                      src: item.imgUrl
                    }, null, 8, _hoisted_16)
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (detail.value.redPacketArticle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                  class: "redBg",
                  src: _imports_3
                }, null, -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, "Envo " + _toDisplayString(_ctx.$t('HB')), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('GXFC')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _cache[4] || (_cache[4] = _createElementVNode("img", { src: _imports_4 }, null, -1)),
              _createTextVNode(" " + _toDisplayString(detail.value && detail.value.likeCount), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[5] || (_cache[5] = _createElementVNode("img", { src: _imports_5 }, null, -1)),
              _createTextVNode(" " + _toDisplayString(detail.value && detail.value.forwardCount), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[6] || (_cache[6] = _createElementVNode("img", { src: _imports_6 }, null, -1)),
              _createTextVNode(" " + _toDisplayString(detail.value && detail.value.collectCount), 1)
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "divider" }, null, -1)),
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('PL')) + "（" + _toDisplayString(commentTotal.value || 0) + "）", 1),
          (commentList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentList.value, (item, index) => {
                  return (_openBlock(), _createBlock(commentItem, {
                    class: "commentItem",
                    data: item,
                    txSixe: "big",
                    key: index
                  }, {
                    comment: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (item2, index2) => {
                        return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                          _createVNode(commentItem, {
                            data: item2,
                            txSixe: "small"
                          }, null, 8, ["data"])
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["data"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (commentList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createTextVNode(_toDisplayString(_ctx.$t('CKQBPL')), 1),
                _cache[7] || (_cache[7] = _createElementVNode("img", { src: _imports_7 }, null, -1))
              ]))
            : _createCommentVNode("", true),
          (commentList.value.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('ZWPL')), 1),
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('HMYEPL')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _cache[9] || (_cache[9] = _createElementVNode("img", { src: _imports_8 }, null, -1)),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('BQ')), 1)
        ])),
    _createVNode(_component_a_button, {
      onClick: _unref(openApp),
      class: "openApp"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('DKAPP')), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}
}

})